/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/adminPage.scss';

import React, {useContext, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {AppContext} from '../misc/appContext';

import {copyToClipboard, navigate} from '@dvrd/dvr-controls';

import AdminConnectionsController from './connections/adminConnectionsController';

import {AdminContext} from '../misc/adminContext';

import {onShowConfirmSnackbar} from '../../util/renderUtil';

import {Outlet, useLocation} from 'react-router';

import {ADMIN_DEFAULT_TEMPLATES_PATH, ADMIN_TEMPLATE_EDITOR_PATH, INVOICES_ROUTE} from '../../util/constants';

import classNames from 'classnames';

export default function AdminController() {
    const {t} = useTranslation();
    const appContext = useContext(AppContext);
    const adminContext = useContext(AdminContext);
    const location = useLocation();
    const showAdminBars = useMemo(() => {
        const dontShowInPaths = [ADMIN_DEFAULT_TEMPLATES_PATH, ADMIN_TEMPLATE_EDITOR_PATH];
        return !dontShowInPaths.find((path: string) => location.pathname.includes(path));
    }, [location]);

    function onCopyData(value?: string) {
        return function () {
            if (value)
                copyToClipboard(value).then(() => {
                    onShowConfirmSnackbar(
                        `'${value}' ${t('admin.copiedToClipboardSuffix', 'gekopieerd naar klembord')}`
                    );
                });
        };
    }

    function renderContextBar() {
        const userId = adminContext.activeUser?.id;
        const userName = adminContext.activeUser?.fullName;
        const accountId = adminContext.activeAccount?.id;
        const accountName = adminContext.activeAccount?.companyName;
        return (
            <div className='context-bar'>
                <div className='part'>
                    <label className='bar-head'>{t('admin.bar.selectedUser', 'Geselecteerde gebruiker')}</label>
                    <label className='click' onClick={onCopyData(userId)}>
                        {t('admin.bar.id', 'ID')}: {userId ?? '-'}
                    </label>
                    <label className='click' onClick={onCopyData(userName)}>
                        {t('admin.bar.name', 'Naam')}: {userName ?? '-'}
                    </label>
                </div>
                <div className='part'>
                    <label className='bar-head'>{t('admin.bar.selectedAccount', 'Geselecteerd account')}</label>
                    <label className='click' onClick={onCopyData(accountId)}>
                        {t('admin.bar.id', 'ID')}: {accountId ?? '-'}
                    </label>
                    <label className='click' onClick={onCopyData(accountName)}>
                        {t('admin.bar.name', 'Naam')}: {accountName ?? '-'}
                    </label>
                </div>
            </div>
        );
    }

    useEffect(() => {
        if (!appContext.userContext.user?.isSupport()) navigate(INVOICES_ROUTE);
    }, []);

    return (
        <div className={classNames('admin-page', showAdminBars && 'with-bars')}>
            {showAdminBars && (
                <>
                    <AdminConnectionsController />
                    {renderContextBar()}
                </>
            )}
            <Outlet />
        </div>
    );
}
